/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { AvailabilityDelayEnum } from './availabilityDelayEnum';
import { NullEnum } from './nullEnum';

/**
 * @nullable
 */
export type TrainingServiceProfileAvailabilityDelay = AvailabilityDelayEnum | NullEnum | null;

export const TrainingServiceProfileAvailabilityDelay = {
  ...AvailabilityDelayEnum,
  ...NullEnum,
} as const;
